export enum CompanyCode {
  HighlightsPortal = 'HEG',
  ZBPortal = 'ZB'
}
